import { forwardRef } from 'react';
import { cn, formatPrice} from '@/shared/lib/utils';
import { NavLink } from 'react-router-dom';
import type { ProjectType } from '@/entities/projects/model/types';

import AreaIcon from "@/assets/icons/spec/area.svg?react";
import ComplatedIcon from "@/assets/icons/spec/complated.svg?react";
import FloorsIcon from "@/assets/icons/spec/floors.svg?react";
import MetroIcon from "@/assets/icons/spec/metro.svg?react";
import RightWhiteArrow from "@/assets/icons/arrow/rightWhite.svg?react";

export interface ProjectMapCardProps {
    project: ProjectType;
    className?: string;
}

export const ProjectMapCard = forwardRef<HTMLDivElement, ProjectMapCardProps>(
    ({ className, project, ...props }, ref) => {

        return (
            <div 
                ref={ref} 
                className={cn('flex flex-col overflow-hidden rounded-[10px] bg-white w-[239px]', className)}
                {...props}
            >
                <img
                    className={cn('w-full object-cover object-center h-[100px]')}
                    src={project.imageUrl || "/images/defaults/card.png"}
                    alt=""
                />

                <div className={cn('flex flex-col p-[12px] pb-[8px] gap-[10px]')}>
                    <span className={cn('font-manrope font-medium font uppercase leading-none text-[14px]')}>
                        {project.title}
                    </span>
                    <span className={cn('normal font-[500] text-black-50 leading-none text-[12px]')}>
                        {project.developer}
                    </span>

                    <div className='flex flex-row gap-[4px] items-center'>
                        <div className='flex items-center gap-[2px]'>
                            <FloorsIcon className='w-[15px] h-[15px]'/>
                            <span className={cn('font-manrope text-black-50 font-normal whitespace-nowrap text-[10px]')}>
                                {project.spec.floor}
                            </span>
                        </div>
                        <div className='flex items-center gap-[2px]'>
                            <AreaIcon className='w-[15px] h-[15px]'/>
                            <span className={cn('font-manrope text-black-50 font-normal whitespace-nowrap text-[10px]')}>
                                {project.spec.areaFrom} м²
                            </span>
                        </div>
                        <div className='flex items-center gap-[2px]'>
                            <ComplatedIcon className='w-[15px] h-[15px]'/>
                            <span className={cn('font-manrope text-black-50 font-normal whitespace-nowrap text-[10px]')}>
                                {project.completionDate} год
                            </span>
                        </div>
                        <div className='flex items-center gap-[2px]'>
                            <MetroIcon className='w-[15px] h-[15px]' />
                            <span className={cn('font-manrope text-black-50 font-normal whitespace-nowrap text-[10px]')}>
                                {project.location.districtId}
                            </span>
                        </div>
                    </div>

                    <div className='flex flex-row justify-between items-center'>
                        <span className={cn('font-manrope font-normal text-black leading-[130%] tracking-normal uppercase text-[14px]')}>
                            {formatPrice(project.priceFrom)}
                        </span>

                        <NavLink to={`/project/${project.id}`}>
                            <div className={cn('flex justify-center items-center bg-blue text-white rounded-full shadow-cls w-[24px] h-[24px]')}>
                                <RightWhiteArrow/>
                            </div>
                        </NavLink>

                    </div>
                </div>
            </div>
        );
    }
);

ProjectMapCard.displayName = 'ProjectMapCard';